import type { Document } from '@/hooks/useDocuments';

export function documentNewTabUrl(
  matterSlug: string,
  document: Pick<Document, 'id' | 'is_drafting_managed' | 'draft_document_guid'>,
): string {
  if (document.is_drafting_managed && document.draft_document_guid) {
    return `/matter/${matterSlug}/drafting/${document.draft_document_guid}`;
  }
  return `/matter/${matterSlug}/f/${document.id}`;
}
